var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 210,
    viewBox: "0 0 150 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_1407)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_438_1407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5 1C35.0034 1 3 29.9951 3 65.9106C3 128.011 74.5 209 74.5 209C74.5 209 146 127.998 146 65.9106C146 30.0081 113.997 1 74.5 1Z",
    fill: "#EF505B"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_438_1407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.6 95.7C94.1 103.2 85 106.9 74.3 106.9C63.6 106.9 54.5 103.2 47.1 95.8C39.7 88.3 36 79.2 36 68.4C36 57.6 39.7 48.5 47.1 41.1C54.6 33.7 63.6 30 74.3 30C85 30 94.1 33.7 101.6 41.1C109.1 48.5 112.8 57.6 112.8 68.4C112.8 79.2 109 88.3 101.6 95.7ZM57.3 85.8C61.9 90.3 67.5 92.6 74.3 92.6C81.1 92.6 86.7 90.3 91.3 85.8C95.9 81.3 98.2 75.5 98.2 68.4C98.2 61.4 95.9 55.6 91.3 51C86.7 46.4 81.1 44.1 74.3 44.1C67.5 44.1 61.9 46.4 57.3 51C52.7 55.6 50.4 61.4 50.4 68.4C50.5 75.5 52.8 81.3 57.3 85.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9 116.4C102.9 117.5 90 118.4 74.1 118.4C58.2 118.4 45.3 117.5 45.3 116.4C45.3 115.3 58.2 114.4 74.1 114.4C90 114.3 102.9 115.3 102.9 116.4Z",
    fill: "#DADADA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_438_1407",
    x: -7,
    y: -5,
    width: 163,
    height: 228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_438_1407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_438_1407",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_1407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 210,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_438_1407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8,
    height: 88.4,
    fill: "white",
    transform: "translate(36 30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/mapMarker.7baf30a983f8f40479bedae90ff800f4.svg";
export { ForwardRef as ReactComponent };